import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React, { useRef } from "react";
import { makeStyles } from "@material-ui/styles";
import { ExcelReader, DataTable, SheetTypes, Grid, Typography, useAsyncState, Divider, Button, Dialog } from "../../..";
var useStyles = makeStyles(function (theme) {
  return {
    root: {
      display: "flex",
      flexDirection: "column",
      "flex-wrap": "wrap"
    },
    flex: {
      display: "flex",
      "justify-content": "space-between"
    },
    w50: {
      width: "50%"
    },
    taxName: {
      "margin-right": "30px",
      width: "40%"
    },
    actions: {
      display: "flex",
      padding: "30px",
      "justify-content": "flex-end"
    },
    mr30: {
      "margin-right": "30px"
    }
  };
});

var DialogImport = function DialogImport(_ref) {
  var translation = _ref.translation,
      columnsImport = _ref.columnsImport,
      props = _objectWithoutProperties(_ref, ["translation", "columnsImport"]);

  // console.log("FILES: ", SheetTypes);
  var classes = useStyles();

  var _useAsyncState = useAsyncState(null),
      _useAsyncState2 = _slicedToArray(_useAsyncState, 2),
      file = _useAsyncState2[0],
      setFile = _useAsyncState2[1];

  var _useAsyncState3 = useAsyncState(null),
      _useAsyncState4 = _slicedToArray(_useAsyncState3, 2),
      dataFile = _useAsyncState4[0],
      setData = _useAsyncState4[1];

  var _useAsyncState5 = useAsyncState("import"),
      _useAsyncState6 = _slicedToArray(_useAsyncState5, 2),
      variant = _useAsyncState6[0],
      setVariant = _useAsyncState6[1];

  var linkTemplateRef = useRef(null);
  var fileRef = useRef(null);

  var handleSelectFile = function handleSelectFile() {
    fileRef.current.click();
  };

  var handleChangeFile = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(event) {
      var files;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              files = event.target.files;

              if (files && files[0]) {
                // console.log(files);
                setFile(files[0]).then(function (auxFile) {
                  setVariant("loading"); // console.log("comienza lectura", auxFile);

                  var reader = new ExcelReader(auxFile, 1);
                  return reader.readFile();
                }).then(function (dataFileReader) {
                  // console.log("lectura finalizada", dataFileReader);
                  if (!dataFileReader[props.titleSheet]) {
                    return setVariant("error");
                  } else {
                    // console.log("read", dataFileReader);
                    return setData(dataFileReader[props.titleSheet]);
                  }
                }).then(function (data) {
                  if (data !== "error") {
                    setVariant("preview");
                  }
                })["catch"](function (err) {
                  // console.log("err", err);
                  setVariant("error");
                });
              }

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleChangeFile(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  var dialogSubmitData = function dialogSubmitData() {
    setVariant("import").then(function (x) {
      props.importData(dataFile["data"]);
    });
  };

  var viewContent = function viewContent() {
    var content;

    switch (variant) {
      case "import":
        content = [props.title_instructions ? /*#__PURE__*/React.createElement(Typography, {
          variant: "body1"
        }, props.title_instructions) : null, props.text_instructions ? /*#__PURE__*/React.createElement(Typography, {
          variant: "body1"
        }, props.text_instructions) : null, props.instructions ? /*#__PURE__*/React.createElement("ul", null, props.instructions.map(function (instruction) {
          return /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(Typography, {
            variant: "body1"
          }, instruction));
        })) : null, /*#__PURE__*/React.createElement("a", {
          href: props.link,
          style: {
            display: "none"
          },
          ref: linkTemplateRef,
          target: "_blank",
          rel: "noopener noreferrer"
        }), /*#__PURE__*/React.createElement(Button, {
          size: "medium",
          className: classes.mr30,
          color: "primary",
          variant: "contained",
          component: "a",
          href: props.link,
          target: "_blank",
          rel: "noopener noreferrer"
        }, translation ? translation.buttons.download_template : "Download template"), /*#__PURE__*/React.createElement(Divider, {
          variant: "middle",
          style: {
            marginTop: "16px",
            marginBottom: "16px"
          }
        }), /*#__PURE__*/React.createElement("input", {
          type: "file",
          style: {
            display: "none"
          },
          ref: fileRef,
          accept: SheetTypes,
          onChange: handleChangeFile
        }), /*#__PURE__*/React.createElement(Button, {
          size: "medium",
          className: classes.mr30,
          color: "primary",
          variant: "outlined",
          onClick: handleSelectFile
        }, translation ? translation.buttons.select : "Select")];
        break;

      case "loading":
        content = /*#__PURE__*/React.createElement(Grid, {
          item: true,
          xs: 12,
          style: {
            textAlign: "center"
          }
        }, /*#__PURE__*/React.createElement(Typography, {
          variant: "body2"
        }, translation ? translation.titles.loading : "Reading file...Please wait."));
        break;

      case "preview":
        // console.log("data preview ", dataFile);
        var columns = [];
        Object.keys(dataFile["columns"]).forEach(function (key) {
          columns.push({
            name: key,
            label: dataFile["columns"][key]
          });
        }); // console.log("columns", columns);
        // console.log("columns import", columnsImport);
        // console.log("columns", JSON.stringify(columns));
        // console.log("data", dataFile);

        var options = _objectSpread(_objectSpread({}, props.options), {}, {
          print: false,
          search: false,
          filter: false,
          download: false,
          viewColumns: false
        });

        content = [/*#__PURE__*/React.createElement(DataTable, {
          translation: translation ? translation.datatables ? translation.datatables.import_contacts : columnsImport ? columnsImport : {
            columns: columns
          } : columnsImport ? columnsImport : {
            columns: columns
          },
          options: options,
          data: dataFile["data"]
        }), /*#__PURE__*/React.createElement(Divider, {
          variant: "middle",
          style: {
            marginTop: "16px",
            marginBottom: "16px"
          }
        }), /*#__PURE__*/React.createElement(Grid, {
          container: true,
          className: classes.actions
        }, /*#__PURE__*/React.createElement(Button, {
          type: "button",
          size: "medium",
          className: classes.mr30,
          color: "secondary",
          variant: "outlined",
          onClick: function onClick() {
            setVariant("import").then(function (x) {
              props.onClose();
            })["catch"](function (err) {
              return console.log(err);
            });
          }
        }, translation ? translation.buttons.cancel : "Cancel"), /*#__PURE__*/React.createElement(Button, {
          size: "medium",
          color: "primary",
          variant: "outlined",
          type: "submit",
          onClick: dialogSubmitData
        }, translation ? translation.buttons["import"] : "Import"))];
        break;

      case "error":
        content = [/*#__PURE__*/React.createElement("div", {
          style: {
            textAlign: "center"
          }
        }, /*#__PURE__*/React.createElement(Typography, {
          variant: "body2"
        }, translation ? translation.titles.error : "Error, wrong template"))];
        break;

      default:
        break;
    }

    return content;
  }; //   handleCloseDialog = () => {
  //     setVariant("import").then();
  //   };


  return /*#__PURE__*/React.createElement(Dialog, {
    maxWidth: "lg",
    title: translation ? translation.title : "Import contacts",
    open: props.open,
    onClose: // props.onClose
    function onClose() {
      setVariant("import").then(function (x) {
        props.onClose();
      })["catch"](function (err) {
        return console.log(err);
      });
    },
    mode: props.variant,
    key: 0
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    className: classes.root
  }, viewContent()));
};

export { DialogImport };